"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withResultsCallback = withResultsCallback;
exports.withMissingItemReplacement = withMissingItemReplacement;
exports.withDelayOnFailure = withDelayOnFailure;
exports.withRetries = withRetries;
exports.asFallback = asFallback;
exports.withFallbackData = withFallbackData;
exports.withShuffledData = withShuffledData;
exports.withRemovalExclusion = withRemovalExclusion;
var Utilities_1 = require("icf-search-client-shared/lib/Utilities");
var shuffle = require("lodash/fp/shuffle");
// TODO: Can probably clean up these generic types to be less verbose.
function withResultsCallback(dataProvider, callback, logger) {
    return function withCallbackDataProvider(request, previousResults) {
        return __awaiter(this, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dataProvider(request, previousResults)];
                    case 1:
                        results = _a.sent();
                        try {
                            callback(results);
                        }
                        catch (error) {
                            // It's unfortunate that the callback failed, but we need
                            // to avoid breaking the render.
                            try {
                                logger.error("Failed to make results callback", error);
                            }
                            catch (logError) {
                                // Prevented a logging error from breaking results.
                                // TODO: Address what to do when the log fails.
                            }
                        }
                        return [2 /*return*/, results];
                }
            });
        });
    };
}
function withMissingItemReplacement(dataProvider, toId, isHeroGridActive) {
    return function missingItemReplacementDataProvider(request, previousResults) {
        return __awaiter(this, void 0, void 0, function () {
            var newResults, replacementResults, resultsWithReplaced;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dataProvider(request, previousResults)];
                    case 1:
                        newResults = _a.sent();
                        // TODO: Remove UI and feature specific logic for hero tile.
                        /* istanbul ignore next */
                        if (isHeroGridActive && window.innerWidth < 1152 && request && request.pageIndex === 0) {
                            newResults.results.splice(5, 0, newResults.results[5]);
                        }
                        if (!previousResults) {
                            return [2 /*return*/, newResults];
                        }
                        replacementResults = newResults.results.filter(function (item) { return !previousResults.results.some(function (i) { return toId(i) === toId(item); }); });
                        resultsWithReplaced = previousResults.results.map(function (item) {
                            var matchingNewResult = newResults.results.find(function (i) { return toId(i) === toId(item); });
                            if (matchingNewResult) {
                                return matchingNewResult;
                            }
                            if (replacementResults.length > 0) {
                                return replacementResults.shift();
                            }
                            // If we don't have a replacement just remove it
                            return null;
                        });
                        return [2 /*return*/, __assign(__assign({}, newResults), { results: resultsWithReplaced.filter(function (item) { return item !== null; }) })];
                }
            });
        });
    };
}
/**
 * TODO: Although this rate-limits repeat requests on failures, it also delays surfacing the error to the user.
 * May need an alternate solution in the future. OTOH, an artificial delay for errors might be better UX...
 */
function withDelayOnFailure(dataProvider, delayMs) {
    if (delayMs === void 0) { delayMs = 5000; }
    return function delayOnFailureDataProvider(request, previousResults) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 4]);
                        return [4 /*yield*/, dataProvider(request, previousResults)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_1 = _a.sent();
                        return [4 /*yield*/, (0, Utilities_1.delay)(delayMs)];
                    case 3:
                        _a.sent();
                        throw error_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
}
function withRetries(dataProvider, retryDelays) {
    return function withRetriesDataProvider(request, previousResults) {
        return __awaiter(this, void 0, void 0, function () {
            var error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!true) return [3 /*break*/, 6];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 5]);
                        return [4 /*yield*/, dataProvider(request, previousResults)];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_2 = _a.sent();
                        if (retryDelays.length === 0) {
                            throw error_2;
                        }
                        return [4 /*yield*/, (0, Utilities_1.delay)(retryDelays.shift())];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 0];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
}
function asFallback(dataProvider) {
    return function asFallbackDataProvider(request, previousResults) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = [{}];
                        return [4 /*yield*/, dataProvider(request, previousResults)];
                    case 1: return [2 /*return*/, __assign.apply(void 0, [__assign.apply(void 0, _a.concat([(_b.sent())])), { isFallback: true }])];
                }
            });
        });
    };
}
function withFallbackData(dataProvider, fallbackDataProvider) {
    return function withFallbackDataProvider(request, previousResults) {
        return __awaiter(this, void 0, void 0, function () {
            var results, fallbackResults, fallbackErrors, errors;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, dataProvider(request, previousResults)];
                    case 1:
                        results = _b.sent();
                        if (!(results.totalItems === 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, asFallback(fallbackDataProvider)(request, previousResults)];
                    case 2:
                        fallbackResults = _b.sent();
                        fallbackErrors = fallbackResults.errors ? fallbackResults.errors : [];
                        errors = fallbackErrors.concat((_a = results.errors) !== null && _a !== void 0 ? _a : []);
                        return [2 /*return*/, __assign(__assign({}, fallbackResults), { errors: errors })];
                    case 3: return [2 /*return*/, results];
                }
            });
        });
    };
}
function withShuffledData(dataProvider) {
    return function withShuffledDataProvider(request, previousResults) {
        return __awaiter(this, void 0, void 0, function () {
            var results;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dataProvider(request, previousResults)];
                    case 1:
                        results = _a.sent();
                        return [2 /*return*/, __assign(__assign({}, results), { results: shuffle(results.results) })];
                }
            });
        });
    };
}
function withRemovalExclusion(dataProvider, removalExclusionIds, toId) {
    return function removalExclusionDataProvider(request, previousResults) {
        return __awaiter(this, void 0, void 0, function () {
            var newResults, retainedItems, resultsWithRetained;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, dataProvider(request, previousResults)];
                    case 1:
                        newResults = _a.sent();
                        if (!previousResults) {
                            return [2 /*return*/, newResults];
                        }
                        retainedItems = previousResults.results
                            .filter(function (item) { var _a; return removalExclusionIds.includes((_a = toId(item)) !== null && _a !== void 0 ? _a : -1); })
                            .map(function (item) {
                            return newResults.results.find(function (newItem) { return toId(newItem) === toId(item); }) || item;
                        });
                        resultsWithRetained = retainedItems
                            .concat(newResults.results.filter(function (item) { return !retainedItems.some(function (retainedItem) { return toId(retainedItem) === toId(item); }); }))
                            .slice(0, newResults.results.length - retainedItems.length + 2);
                        return [2 /*return*/, __assign(__assign({}, newResults), { results: resultsWithRetained })];
                }
            });
        });
    };
}
//# sourceMappingURL=DataProviderDecorators.js.map